export const project4Hospitality = {
  uuid: 'c3d4e5f6-a7b8-4901-c234-56789abcdef0',
  date: '19 Mar 2025',
  readingTime: '5 min read',
  lead:
    'This page is a blog-style summary (easy to edit). The full PDF report is kept at the end.',
  sections: [
    {
      number: '01',
      label: 'Demo',
      heading: 'Demo (placeholder)',
      paragraphs: [
        'Demo text: describe scenario-based walkthroughs for hospitality use-cases (inputs → recommendations).',
      ],
      quote: {
        pill: 'DEMO',
        text: '“Example flows, recommendations, and evaluation notes.”',
      },
    },
    {
      number: '02',
      label: 'Overview',
      heading: 'What this highlight covers',
      paragraphs: [
        'Summarize the use-cases, approach, evaluation, and what improved.',
      ],
      bullets: [
        { bold: 'Use-case', text: 'what hospitality problem was addressed.' },
        { bold: 'Approach', text: 'how the solution generates recommendations.' },
        { bold: 'Impact', text: 'expected outcomes and learnings.' },
      ],
    },
    {
      number: '03',
      label: 'Notes',
      heading: 'Key notes',
      paragraphs: [
        'Add constraints, risks, and future improvements here.',
      ],
    },
  ],
};

